import React, { useState, useEffect } from 'react';
import {
    Button,
    Menu, Tooltip,
    Typography, Skeleton
} from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    getDestinationsFxn,
    getBearerTokenFxn
} from "./actions";

import './esim.css';
import AllDestinationsPage from "./allDestinations";

const { Title, Text } = Typography;


const ApplyEsimPackage = () => {

    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        const fetchTokenAndDestinations = async () => {

            getDestinationsFxn({ type: 1 }).then((dest1) => {
                if (dest1.success && dest1.data.data) {
                    dispatch({ type: 'SET_DESTINATIONS_TYPE_1', payload: dest1.data.data })
                }
            })
            getDestinationsFxn({ type: 2 }).then((dest1) => {
                if (dest1.success && dest1.data.data) {
                    dispatch({ type: 'SET_DESTINATIONS_TYPE_2', payload: dest1.data.data })
                }
            })
            getDestinationsFxn({ type: 3 }).then((dest1) => {
                if (dest1.success && dest1.data.data) {
                    dispatch({ type: 'SET_DESTINATIONS_TYPE_3', payload: dest1.data.data })
                }
            })
        };

        fetchTokenAndDestinations();
    }, []);


    useEffect(() => {
        dispatch({ type: 'RESET_ESIM'});
    },[])

    const handlePackageClick = () => {
        history.push('/esim-list')
    }


    return (
        <div className="apply-esim-container">
            <div className="apply-esim-wrapper">
                <div className="sort-box-table mark-btn float-right">
                                    <span className={'sort-box-table-right'}>
                                          <Tooltip title={'Package List'}>
                                           <Button onClick={handlePackageClick}
                                                   className={'roundBtn'}>
                                                    Purchased E-SIM List
                                                    </Button>
                                                    </Tooltip>
                                    </span>
                </div>
                <div className="apply-esim-header">
                    <Title level={1} className="apply-esim-header-title">
                        Stay Connected Worldwide
                    </Title>
                    <Text style={{ fontSize: '18px' }}>
                        Get instant connectivity with our premium eSIM packages. No physical SIM required!
                    </Text>


                </div>

                {/* Dropdown Section */}

                <AllDestinationsPage/>

            </div>
        </div>
    );
};

export default ApplyEsimPackage;
